<template>
  <div class="ad" v-if="showModal">
    <img src="../../static/images/home/zixun2.png" />
    <div>
      <div class="desc">
        一匠为企业提供 &nbsp;&nbsp;<span>专业知识</span>&nbsp;&nbsp; 和&nbsp;&nbsp; <span>创新技术</span>&nbsp;&nbsp; ，助力创业者数字化转型
      </div>
      <div class="choose">
        <span>应用开发，就选一匠</span>
        <span>免费咨询热线：<span class="phone">13824289487</span></span>
      </div>
    </div>
    <div class="btn" @click="openConsult">立即咨询</div>
    <div class="close" @click="closeAd">x</div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      showModal:true
    }
  },
  mounted:{
    
  },
  methods:{
    closeAd(){
      this.showModal = !this.showModal;
    },
    openConsult(){
      this.$addConsult()
    }
  }
};
</script>
<style lang="stylus" scoped>
.ad {
  width:100%;
  position: fixed;
  bottom:0px;
  left:0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 136px;
  background: #FFC000;
  z-index:8;

  img {
    top: -40px;
    left: 186px;
    position: absolute;
  }

  .desc {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #12161B;

    span {
      font-size: 22px;
      color: #fff;
    }
  }

  .choose {
    display: flex;
    justify-content: space-between;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #12171A;
    margin-top: 36px;

    .phone {
      color: #fff;
    }
  }

  .btn {
    text-align: center;
    line-height: 52px;
    width: 120px;
    height: 52px;
    background: #12171A;
    border-radius: 4px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-left: 138px;
     cursor:pointer;
  }

  .close {
    position:absolute;
    top:12px;
    right:240px;
    width: 20px;
    height: 20px;
    border: 1px solid #FFFFFF;
    border-radius: 50%;
    color:#fff;
    text-align:center;
    line-height:15px;
    cursor:pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/HomeAdvisory.vue